import { render, staticRenderFns } from "./clock.vue?vue&type=template&id=4130061d&scoped=true"
import script from "./clock.vue?vue&type=script&lang=js"
export * from "./clock.vue?vue&type=script&lang=js"
import style0 from "./clock.vue?vue&type=style&index=0&id=4130061d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4130061d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4130061d')) {
      api.createRecord('4130061d', component.options)
    } else {
      api.reload('4130061d', component.options)
    }
    module.hot.accept("./clock.vue?vue&type=template&id=4130061d&scoped=true", function () {
      api.rerender('4130061d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hr/attendance/statistics/clock.vue"
export default component.exports